<template>
<div class="chapter">
<div class="inner_page">
<p class="chblockx"><a id="page_2"></a>We can’t stop tornadoes. But we can live<br/>through them when we know how.</p>
<p class="chattributex"><em>Tornado Warning: A Booklet for Boys and Girls</em> (1981)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?2c0485fc